import 'css-chunksrc/client/scenes/project/styles.scss';export default {
  "project": "_project_ccybs_1",
  "nameForm": "_nameForm_ccybs_7",
  "dateForm": "_dateForm_ccybs_11",
  "title": "_title_ccybs_16",
  "main": "_main_ccybs_29",
  "column": "_column_ccybs_36",
  "section": "_section_ccybs_44",
  "tagsGroup": "_tagsGroup_ccybs_56",
  "projectPortfoliosList": "_projectPortfoliosList_ccybs_66",
  "tags": "_tags_ccybs_56",
  "sectionStatusTask": "_sectionStatusTask_ccybs_74",
  "heading": "_heading_ccybs_86",
  "subTitle": "_subTitle_ccybs_95",
  "subTitleStatus": "_subTitleStatus_ccybs_101",
  "message": "_message_ccybs_108",
  "button": "_button_ccybs_114",
  "loader": "_loader_ccybs_133",
  "close": "_close_ccybs_143",
  "closeButton": "_closeButton_ccybs_149",
  "headingRight": "_headingRight_ccybs_153",
  "contentProjectRedirection": "_contentProjectRedirection_ccybs_161",
  "configurationIcon": "_configurationIcon_ccybs_165",
  "secondaryCriteria": "_secondaryCriteria_ccybs_175",
  "secondaryCriteriaForm": "_secondaryCriteriaForm_ccybs_182",
  "dates": "_dates_ccybs_187",
  "date": "_date_ccybs_11",
  "status": "_status_ccybs_200",
  "criteriatags": "_criteriatags_ccybs_207",
  "icon": "_icon_ccybs_214",
  "name": "_name_ccybs_7",
  "weather": "_weather_ccybs_235",
  "weatherIcon": "_weatherIcon_ccybs_241",
  "avatar": "_avatar_ccybs_246",
  "container": "_container_ccybs_254",
  "activityMonitoring": "_activityMonitoring_ccybs_261",
  "workload": "_workload_ccybs_262",
  "budget": "_budget_ccybs_263",
  "text": "_text_ccybs_282",
  "positive": "_positive_ccybs_286",
  "warning": "_warning_ccybs_290",
  "contextualMenu": "_contextualMenu_ccybs_294",
  "opened": "_opened_ccybs_294",
  "col": "_col_ccybs_36",
  "zone": "_zone_ccybs_304"
};